/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".parent[_ngcontent-%COMP%]   .logomain[_ngcontent-%COMP%]{box-shadow:0 1px 0 #4f4e4e}"];
export { styles as styles };

